export const PERSONAL = 'personal';
export const DONATION = 'donation';
export const COMPANY = 'company';
export const DUPLICATE = 'duplicate';
